import { addCache } from 'api/caching'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { UpdatePayload } from 'types'

import { CerebroResourceResponse } from '../types'

export const getDspAdvertiser = (
    advertiserId: string
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get(`/api/dsp_advertiser/${advertiserId}/`)

export const getDspAdvertisers = (
    params = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get('/api/dsp_advertisers/', { params })
addCache(getDspAdvertisers)

export const getDspOrder = (
    orderId: string
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get(`/api/dsp_order/${orderId}/`)

export const getDspOrders = (
    params = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get('/api/dsp_orders/', { params })

export const updateDspOrder = (
    orderId: string,
    data: any
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch(`/api/dsp_order/${orderId}/`, data)

export const updateDspOrders = (
    data: UpdatePayload,
    params = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch('/api/dsp_orders/', data, { params })

export const getDspLineItem = (
    lineItemId: string
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get(`/api/dsp_line_item/${lineItemId}/`)

export const updateDspLineItem = (
    lineItemId: string,
    data: any
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch(`/api/dsp_line_item/${lineItemId}/`, data)

export const getDspLineItems = (
    params = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.get('/api/dsp_line_items/', { params })

export const updateDspLineItems = (
    data: UpdatePayload,
    params: any = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch('/api/dsp_line_items/', data, { params })
